import { GDKError } from '@golden/gdk-base';
export const ignoreGDKErrors = (codes) => (event, hint) => {
    const error = hint.originalException;
    if (error && error instanceof GDKError && codes.includes(error.code)) {
        return null;
    }
    return event;
};
//# sourceMappingURL=ignoreGDKErrors.js.map